import React from 'react';

// DEPENDENCIES
import { Accordion } from 'react-bootstrap';

// HELPERS
import { useDealTasks } from '../helpers/DealTasksProvider';

// LOCAL COMPONENTS
import TaskItem from './TaskItem';
import TasksClose from '../tools/TasksClose';

// STYLES
import styles from './tasksCollapse.module.scss';

// MAIN COMPONENT
const TasksCollapse = ({
  children, //
  record: { sales_id, tasks },
  rowNumber,
  resizeRow
}) => {
  const { expanded = {} } = useDealTasks() || {};

  const isExpanded = expanded[sales_id];

  return !tasks?.length ? (
    children
  ) : (
    <Accordion defaultActiveKey={isExpanded ? sales_id : undefined} className="p-0">
      <div className="d-flex w-100">{children}</div>
      <div className={styles.container}>
        <Accordion.Collapse eventKey={sales_id} className={styles.collapse}>
          <div className={styles.outer}>
            <div className={styles.inner}>
              {tasks.map((task, i) => (
                <TaskItem key={i} taskNumber={i + 1} task={task} rowNumber={rowNumber} />
              ))}
            </div>
          </div>
        </Accordion.Collapse>
        <TasksClose className={styles.closeButton} eventKey={sales_id} resizeRow={resizeRow} />
      </div>
    </Accordion>
  );
};

// EXPORT
export default TasksCollapse;
